import { IsArray, IsNotEmpty } from 'class-validator';
import { Type } from 'class-transformer';

import { TimezoneExceptionDto } from './timezone-exception.dto';

export class CreateCompanyTimezoneExceptionsDto {
  @Type(() => TimezoneExceptionDto)
  @IsArray()
  @IsNotEmpty({ message: 'Обязательное поле' })
  timezoneExceptions: TimezoneExceptionDto[];
}
